module.exports = __webpack_public_path__ + "static/media/typing.5802dbf7.svg";